// Keys holding the Gate session. Kept in one place so a failed refresh drops exactly the
// session and nothing else - the login flow keeps its own state in localStorage
// ('ms-state', 'ms-redirect', 'tool-login', 'redirect-server') and must survive it.
const AUTH_STORAGE_KEYS = ['token', 'token_expires', 'refresh_token', 'temp_tenant_token'];

export function clearStoredAuth() {
    try {
        AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    } catch { /* ignore storage errors */ }
}
